import { Injectable } from '@angular/core';
import { GahGroups } from '@data/schema/gah-groups';
import { UserStoreService } from '@gah-core/services/user-store.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };

  constructor(private userStoreService: UserStoreService,) { }

  removeSpecialCharacters(input: string): string {
    // Define the regular expression to match special characters
    const regex = /[!@#$%^&*(),.?":{}|<>-]/g;
    // Use the replace method to remove the special characters
    const result = input.replace(regex, '');
    return result;
  }

  /**
   * Function - send data to analytics (GAHR1199)
   */
   sendDataToAnalytics(eventData:any) {
        if(this.userStoreService.userState && this.userStoreService.userState.selectedTerritory) {
          if(this.userStoreService.userState.selectedTerritory.groupTypeCode) {
            var group:string = null;
            const gahGroups = new GahGroups();//GAHR1243
            const groupsMap = gahGroups.gahGroupsMap;
            if(groupsMap.hasOwnProperty(this.userStoreService.userState.selectedTerritory.groupTypeCode)) {
              group = groupsMap[this.userStoreService.userState.selectedTerritory.groupTypeCode];
              eventData['user_group'] = group;
            }
          if(this.userStoreService.userState.selectedTerritory.territoryName) {
            eventData['user_country'] = this.userStoreService.userState.selectedTerritory.territoryName;
          }
        }
      }
      if(this.userStoreService.userState?.gigyauid) {
        eventData['user_type'] = 'External';
        eventData['user_uuid'] = this.userStoreService.userState?.gigyauid;
      }
      else {
        eventData['user_type'] = 'Internal';
      }
      const window = this.browserGlobals.windowRef();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(
        { event: eventData.event, page: eventData }
      );
      console.log(eventData);
   }

   getEventSource() {
    const window = this.browserGlobals.windowRef();
    const reverseDataLayer = window.dataLayer.slice().reverse();
    const gahGroups = new GahGroups();
    const gahEvents = gahGroups.gahEvents;
    for (const event of reverseDataLayer) {
        if (event.event && gahEvents.includes(event.event)) {
            return event.page.page_name;
        }
    }

    return null; // Or handle the case when no event from the array is found
}
}